import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { ApiLoader } from 'components';
import { fetchUserConvsArchiveDetails } from 'redux/convsArchive/convsArchive.actions';
import UserInfo from './components/UserInfo';
import ConversationCard from './components/ConversationCard';
import styles from './styles.module.scss';

const getUserConvsArchive = ({ convsArchiveData }) =>
  convsArchiveData.user.data;

function UserDetailsArchive() {
  const { conversationId } = useParams();
  const userConvsArchive = useSelector(getUserConvsArchive);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUserConvsArchiveDetails(conversationId));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!userConvsArchive) return <ApiLoader />;

  return (
    <section className={styles.user_details_conv_archive_page}>
      {/* user's info */}
      <div className={styles.user_info}>
        <UserInfo data={userConvsArchive} />
      </div>

      {/* conversation info */}
      <div className={styles.conversations_details}>
        {userConvsArchive.conversations.map((conv) => (
          <ConversationCard data={conv} />
        ))}
      </div>
    </section>
  );
}

export default UserDetailsArchive;
